<template>
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    aria-hidden="true"
  >
    <path d="M7 8.52C7 7.68 7.68 7 8.52 7h12.96c.84 0 1.52.68 1.52 1.52v12.96a1.52 1.52 0 0 1-3.05 0V12.2L9.6 22.55a1.52 1.52 0 0 1-2.15-2.15L17.8 10.05H8.52C7.68 10.05 7 9.37 7 8.52Z" fill="currentColor" />
  </svg>
</template>
